import { colors } from '@ublend-npm/aulaui-next-web/themes/default';

// Themes
const aula = {
  r: 96,
  g: 13,
  b: 159,
  contrast: {
    r: 255,
    g: 255,
    b: 255,
  },
};

const defaultTheme = aula;

// Functions
const equate = (color, alpha = 1, background = 255) =>
  Math.round(alpha * color + (1 - alpha) * background);

const equateColor = (color, alpha, background) => ({
  r: equate(color.r, alpha, background),
  g: equate(color.g, alpha, background),
  b: equate(color.b, alpha, background),
});

const defaultRGB = (alpha, background) =>
  equateColor(defaultTheme, alpha, background);

const convertToCSS = (color) => `rgb(${color.r}, ${color.g}, ${color.b})`;
const convertToCSSA = (color, alpha) =>
  `rgba(${color.r}, ${color.g}, ${color.b}, ${alpha})`;

const defaultColor = (alpha, background) =>
  convertToCSS(defaultRGB(alpha, background));

// Main Color
export const light = defaultColor(0.9);
export default (alpha, background) => defaultColor(alpha, background);

// Contrast color
export const contrast = convertToCSS(defaultTheme.contrast);
export const contrastAlpha = (alpha) =>
  convertToCSSA(defaultTheme.contrast, alpha);

export const muiTheme = {
  fontFamily: 'Work Sans, sans-serif',
  palette: {
    primary1Color: colors.green0,
    primary2Color: colors.green1,
    accent1Color: colors.secondary,
    textColor: colors.text,
    alternateTextColor: colors.alternateText,
    pickerHeaderColor: colors.green0,
    shadowColor: colors.black,
  },
  overlay: {
    backgroundColor: colors.overlay,
  },
};
